import React from 'react';
import { Archive } from 'lucide-react';
import { RecordCard, EmptyState } from './RecordHelpers';

export const ArchivedTab = ({ archivedRecords, term }) => {
  const filtered = archivedRecords.filter(r => (r.title || '').toLowerCase().includes(term));
  return filtered.length === 0 ? (
    <EmptyState icon={Archive} message="No archived records" sub="Records will appear here after they are archived based on your retention settings" />
  ) : (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
      {filtered.map(r => <RecordCard key={r.id} record={r} />)}
    </div>
  );
};
